<template>
  <div class="container doc service">
    <h1>愛接送 預約式通用(無障礙)計程車乘客服務條款</h1>
    <section>
      <p>
        一、為落實照顧行動不便者出行需求，臺北市政府交通局、新北市政府交通局、桃園市政府交通局與臺中市政府交通局
        (以下簡稱交通局)參與愛接送
        預約式通用(無障礙)計程車特約車隊制度，利用愛接送
        預約式通用(無障礙)計程車平台(以下簡本稱平台)整合通用計程車供給與使用者需求，透過本平台網站及行動裝置APP提供乘客預約服務。並為規範乘客權利義務，訂定本乘客服務須知
      </p>
      <p>二、預約平台與APP下載</p>
      <p>
        雙北<a href="https://itaxi.ntpc.net.tw/">https://itaxi.ntpc.net.tw/</a>
        ；桃園<a href="https://itaxi.tycg.gov.tw/"
          >https://itaxi.tycg.gov.tw/ </a
        >；台中<a href="https://itaxi.taichung.gov.tw">
          https://itaxi.taichung.gov.tw</a
        >；行動裝置APP名稱為：「愛˙接送」，iOS裝置請至APP
        STORE下載，Android裝置請至GOOGLE PLAY下載
      </p>
      <p>
        三、本須知所指通用計程車，係指符合道路交通安全規則第四十二條及車輛安全檢測基準第六十七點設置輪椅區之計程車；駕駛人係指符合汽車運輸業管理規則第九十一條之三，參加公路主管機關或其委託辦理之訓練並領得結訓證書之計程車駕駛人；特約車隊係指與交通局簽訂通用計程車特約車隊合約之計程車隊。
      </p>
      <p>
        四、為使服務更有效率，維持服務品質與水準，乘客未依規定辦理服務變更、取消，致他人乘車權益受損，採違規記點方式處理。
      </p>
      <p>
        五、乘客依計程車計費表顯示車資付費，下車時可向駕駛人索取收據。駕駛人若有超收車資情事，請依第十九條規定申訴。
      </p>
      <p>
        六、預約平台接受民眾預約通用計程車服務，依預約乘車時間先後，排定服務對象用車順序，額滿列入候補清單。
      </p>
      <p>
        七、一般預約：乘客至遲須於用車前一日下午二時前完成預約，系統於用車前一日下午八時前，以電子郵件或行動APP通知隔日乘車時間與車號。
      </p>
      <p>
        八、臨時預約：乘客如遇臨時乘車之需要，亦可透過APP或預約系統登錄需求。惟因車隊調度作業須優先服務一般預約者，臨時預約趟次需視該時段與路段是否有空閒車輛可以提供服務，不保證臨時預約乘客可以預約成功。
      </p>
      <p>
        九、乘客應於乘車時間前，至乘車地點等候乘車；為避免影響下一趟次乘客權益，駕駛人至多停留十分鐘等候乘客乘車，以系統紀錄時間為準。
      </p>
      <p>十、乘客取消預約，至遲應於搭車前一日下午二時前取消預約。</p>
      <p>
        十一、
        乘客變更乘車時間或上、下車地點，應依前條規定取消預約後，重新預約，駕駛不接受臨時變更上、下車地點。
      </p>
      <p>
        十二、
        未避免浪費有限之運輸資源致影響其他乘客預約權益，臨時取消應於乘車時間前二小時以前取消預約，並記違規一點。未於前述時間內取消預約，視同爽約，記違規二點。
      </p>
      <p>
        十三、
        乘客應於乘車時間前，至乘車地點等候乘車，逾時十分鐘未抵達乘車地點上車者，記違規二點，並視同放棄當日服務。
      </p>
      <p>
        十四、
        乘客於試辦期間累計違規五點者，自發生之日起，暫停受理預約四十五日曆天。
      </p>
      <p>
        十五、
        乘客經暫停受理預約，自期滿次日起恢復提供預約服務，違規記點清除重新累計。
      </p>
      <p>
        十六、
        乘客自第一次違規記點日起，三十日曆天內未受違規記點處分，違規記點清除重新累計。
      </p>
      <p>十七、 乘客有下列情形之一者，駕駛人得拒絕其搭乘：</p>

      <ul>
        <li>(一) 身患傳染病者。</li>
        <li>(二) 兒童過於幼小無人護送者。</li>
        <li>(三) 酗酒或狀似瘋癲者。</li>
        <li>
          (四)
          攜帶違禁品、危險品、易生變壞或破損之物品、不潔或易污損他物之物品、厭惡品。
        </li>
        <li>
          (五)
          不適宜隨客車運送之動物類。但視覺、聽覺、肢體功能障礙者攜帶之導盲犬、導聾犬、肢體輔助犬，或導盲犬、導聾犬、肢體輔助犬專業訓練人員於執行訓練時攜帶之幼犬不在此限。
        </li>
      </ul>
      <p>
        十八、
        搭乘路線應依雙方同意或指定之行車方式行駛。但如遇集會地區、臨時交通管制區、機械故障、氣候變化，或其他必要情況，得與駕駛人雙方協議後調整變更。
      </p>
      <p>
        十九、
        為維護乘客乘車權益，可透過平台網站及行動裝置APP，於預約系統提出申訴或相關建議。
      </p>
    </section>
  </div>
</template>
